exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-card[data-v-588113a9] {\n  background-image: linear-gradient(135deg, #e934d5, #6c3e9a);\n}\n.small-card__title[data-v-588113a9] {\n  color: #fff;\n  font-size: 12px;\n  font-weight: normal;\n}", ""]);

// exports
